import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import * as referService from "../../services/refer-and-earn.service";
import { useTranslation } from "react-i18next";

const ReferAndEarnView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Refers", url: "/admin/refer-and-earn/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    referService
      .Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View Business</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>User Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.user?.fullName) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>User Email</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.user?.email) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Refer User Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault?.referrer?.fullName) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Refer User Email</th>
                          <td>{capitalizeFirstLetter(showdefault?.referrer?.email) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Refered Code</th>
                          <td className="text-capitalize">{showdefault.referedCode || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Refer User Current Points</th>
                          <td className="text-capitalize">{showdefault.referUserCurrentPoints || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>{showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        back
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferAndEarnView;
